<template>
    <div class="overlay">
        <div class="overlay-text">
            <div class="password">
                <el-input v-model="password" type="password" style="width: 200px" @keyup.enter="submit()" />
            </div>
            <div class="submit">
                <el-button @click="submit()">OK</el-button>
            </div>
        </div>
    </div>
</template>
<style scoped>
/* 全屏遮罩层的样式 */
.overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    /* 宽度和高度都设置为100%，覆盖整个视口 */
    height: 100%;
    background-color: rgba(37, 37, 37, 1);
    z-index: 999;
    /* 确保在其他元素之上 */
    display: flex;
    /* 使用 flex 布局使内容垂直和水平居中 */
    justify-content: center;
    align-items: center;
}

/* 可选的文本样式 */
.overlay-text {
    color: #3da1d3;
    width: 300px;
    margin: 0 auto;
}

.password {
    text-align: center;
    margin: 0 auto 20px auto;
}

.submit {
    margin: 0 auto;
    text-align: center;
}

@keyframes spin {
    0% {
        transform: rotate(0deg);
    }

    100% {
        transform: rotate(360deg);
    }
}
</style>

<script setup>
import { ref, inject, onMounted } from 'vue'
import { useSystemStore } from '@/stores/system'
import { ElMessage } from 'element-plus'

const homeActions = inject('homeActions')
const password = ref('')
const systemStore = useSystemStore()

const submit = () => {
    if (!password.value) {
        ElMessage.error('请输入密码')
        return
    }
    systemStore.setPassword(password.value)
    homeActions?.loginReady()
}

const autoLoginFromElectron = async () => {
    const getLoginPassword = window.electronAPI?.getLoginPassword

    if (typeof getLoginPassword !== 'function') {
        return
    }

    try {
        const electronPassword = await getLoginPassword()

        if (!electronPassword) {
            return
        }

        password.value = electronPassword
        submit()
    } catch (error) {
        console.error('Failed to read Electron login password:', error)
    }
}

onMounted(() => {
    autoLoginFromElectron()
})

</script>
